import { Marker, type Map as MLMap } from 'maplibre-gl';
import type { LngLat } from '../shared/types';

/**
 * 自車表示（2D の矢印マーカー）。
 * 3D モデルは layers/threeLayer.ts に置き換え可能にしてあり、どちらも同じ update() を受ける。
 */
export interface VehicleView {
  update(position: LngLat, bearing: number): void;
  setVisible(v: boolean): void;
}

export class ArrowVehicle implements VehicleView {
  private readonly marker: Marker;
  private readonly el: HTMLDivElement;
  private added = false;

  constructor(private readonly map: MLMap) {
    this.el = document.createElement('div');
    this.el.className = 'vehicle-arrow';
    this.el.innerHTML = `<svg viewBox="0 0 40 40" width="40" height="40" aria-hidden="true">
      <circle cx="20" cy="20" r="18" fill="#fff" fill-opacity=".9"/>
      <path d="M20 5 L31 32 L20 26 L9 32 Z" fill="#3d8bff" stroke="#0b3d91" stroke-width="2" stroke-linejoin="round"/>
    </svg>`;
    this.marker = new Marker({ element: this.el, rotationAlignment: 'map', pitchAlignment: 'map' });
  }

  update(position: LngLat, bearing: number): void {
    this.marker.setLngLat(position).setRotation(bearing);
    if (!this.added) {
      this.marker.addTo(this.map);
      this.added = true;
    }
  }

  setVisible(v: boolean): void {
    this.el.style.display = v ? '' : 'none';
  }
}
